<template>
  <div class="cat-conditional-fields">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatConditionalGroup"
});
</script>
